document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".theme-hover-trigger");
  const main = document.querySelector("main");

  const HOVER_DELAY = 200;

  let isScrolling = false;
  let scrollTimeout = null;

  /* =========================
     SCROLL DETECTION
  ========================= */
  window.addEventListener(
    "scroll",
    () => {
      isScrolling = true;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
      }, 50); // tweak if needed
    },
    { passive: true }
  );

  /* =========================
     HOVER LOGIC (DELAYED)
  ========================= */
  triggers.forEach((trigger) => {
    let hoverTimer = null;

    trigger.addEventListener("mouseenter", () => {
      // 🚫 Ignore hover if user is scrolling
      if (isScrolling) return;

      hoverTimer = setTimeout(() => {
        main.classList.add("theme-hover");
        document.body.classList.add("dark-theme");
      }, HOVER_DELAY);
    });

    trigger.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimer);
      hoverTimer = null;

      main.classList.remove("theme-hover");
      document.body.classList.remove("dark-theme");
    });
  });
});